// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"20359781","528":"b0c1359e","647":"58574c99","677":"9dc543de","803":"24e717c6"}[chunkId] + ".chunk.js";
};